import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { Filter, LotteryFilterParam } from '../../models/filter.model';
import { DatabaseService } from '../../../../core/_services/database.service';
import { LottolocaNumber } from '../../models/grid-number.model';

@Component({
  selector: 'kt-filter-editor',
  templateUrl: './filter-editor.component.html',
  styleUrls: ['./filter-editor.component.scss']
})
export class FilterEditorComponent implements OnInit, OnChanges {


  @Input() public cols: number = 10;
  @Input() public rows: number = 10;
  @Input() public lotteryId: string;
  @Input() public numberList: LottolocaNumber[] = [];
  @Input() public headerNumberList: LottolocaNumber[] = [];
  @Input() public filter: Filter;
  @Input() public filterParam: LotteryFilterParam = null; _saveButton: boolean;
  @Input() public showSaveButton: boolean = true;
  @Input() public betId: string = null;

  @Output() public changeParams: EventEmitter<LotteryFilterParam> = new EventEmitter();
  @Output() public savedParams: EventEmitter<LotteryFilterParam> = new EventEmitter();

  public _min: number = 0;
  public _max: number = 0;

  public _isReady = false;

  constructor(public _database: DatabaseService) {


  }
  ngOnChanges(changes: SimpleChanges): void {

    console.log("FilterEditorComponent: ngOnChanges", changes);
    this.refresh();

  }

  ngOnInit() {

    this.refresh();

  }

  public refresh() {


    if (this.filter != null) {


      this._min = this.filter.minDefault;
      this._max = this.filter.maxDefault;

      //if (this.betId == null) 
        {
        this._database.getCurrentCustomer().getLottery(this.lotteryId)
          .getFiltersParams()
          .getFilterParam(this.filter.id)
          .getData()
          .then(filterParam => {

            let isChecked = false; 
            if (filterParam != null) {
              this._min = filterParam.minLimit;
              this._max = filterParam.maxLimit;
               isChecked = filterParam.isChecked; 
            }

            this.filterParam = new LotteryFilterParam();

            this.filterParam.id = this.filter.id;
            this.filterParam.maxLimit = this._max;
            this.filterParam.minLimit = this._min;
            this.filterParam.isChecked = isChecked;
            this.filterParam.customerOwner = this.filter.customerOwner;

            this.changeParams.emit(this.filterParam);

            this._isReady = true;
          });

        this._saveButton = false;
      }
     
    }
  }

  changeMaxLimit(value: any) {
    this.filterParam.maxLimit = this._max = parseInt(value);

    this.changeParams.emit(this.filterParam);

    this._saveButton = true;
  }


  changeMinLimit(value: any) {
    this.filterParam.minLimit = this._min = parseInt(value);

    this.changeParams.emit(this.filterParam);
    this._saveButton = true;
  }

  public saveChanges() {

   // if (this.betId == null) 
      
      {
      this._database.getCurrentCustomer().getLottery(this.lotteryId)
        .getFiltersParams()
        .getFilterParam(this.filter.id)
        .update(this.filterParam)
        .then(() => {
          this._saveButton = false;
          this.savedParams.emit(this.filterParam);
        });

    }

  }
}
